import { render, staticRenderFns } from "./Object3dModel.vue?vue&type=template&id=6894ce16&scoped=true&"
import script from "./Object3dModel.vue?vue&type=script&lang=ts&"
export * from "./Object3dModel.vue?vue&type=script&lang=ts&"
import style0 from "./Object3dModel.vue?vue&type=style&index=0&id=6894ce16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6894ce16",
  null
  
)

export default component.exports